// Plugins
import vuetify from './vuetify'
import pinia from '../stores'
import router from '../router'
import axios from './axios'
import socketIo from './socket.io'
import * as Sentry from "@sentry/vue"
import '@/plugins/echarts';
// @ts-ignore
import { registerSW } from 'virtual:pwa-register';

// Types
import type { App } from 'vue'

// App Store
import { useAppStore } from '@/stores/app'

export function registerPlugins (app: App) {
  Sentry.init({
    app,
    dsn: "https://16d071405a32a7b37bb866f1a19e86ac@o4509323308564480.ingest.us.sentry.io/4509323311120384",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],
    // Tracing
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", "https://afsecretaria.com.br"],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  app
    .use(vuetify)
    .use(router)
    .use(pinia)
    .use(appVueInstance => {
      appVueInstance.config.globalProperties.axios = axios
      appVueInstance.config.globalProperties.getBaseUrl = () => import.meta.env.VITE_API_URL.length === 1 ? window.location.origin : import.meta.env.VITE_API_URL
      appVueInstance.config.globalProperties.socket = socketIo
      appVueInstance.config.globalProperties.$store = useAppStore()
      appVueInstance.config.globalProperties.$isMobile = () => vuetify.display.mobile.value
    })

  registerSW({
    immediate: true,
    onNeedRefresh() {},
    onOfflineReady() {}
  });
}
